<template>
  <div id="app">
    <div class="wrapper" style="height: auto; min-height: 100%;">
      <the-header></the-header>
      <content-wrap></content-wrap>
      <!-- Full Width Column -->
      <!-- /.content-wrapper -->
    </div>
  </div>
</template>
<script>
import TheHeader from './TheHeader'
import ContentWrap from './ContentWrap'

export default {
  name: 'TheContainer',
  components: {
    TheHeader,
    ContentWrap
  }
}
</script>
